import { useState, useCallback } from 'react';
import promptService from '../../services/promptService';

/**
 * Custom hook to manage prompt types
 * @param {string} tenantId - The tenant ID
 * @returns {Object} - Prompt types and related methods
 */
const usePromptTypes = (tenantId) => {
	const [promptTypes, setPromptTypes] = useState([]);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(null);

	/**
	 * Fetch prompt types from the API
	 */
	const fetchPromptTypes = useCallback(async () => {
		if (!tenantId) return;

		setLoading(true);
		setError(null);

		try {
			const types = await promptService.getPromptTypes(tenantId);
			setPromptTypes(types);
			return types;
		} catch (err) {
			console.error('Failed to fetch prompt types:', err);
			setError(err.message || 'Failed to load prompt types');
			throw err;
		} finally {
			setLoading(false);
		}
	}, [tenantId]);

	return {
		promptTypes,
		loading,
		error,
		fetchPromptTypes,
	};
};

export default usePromptTypes;
